import React from 'react'
import { makeStyles, TableCell, TableRow, Typography } from "@material-ui/core"
import LinkButton from "../../../shared/components/LinkButton";
import { SECONDARY_COLOR, LIGHT_GRAY_COLOR } from '../../../theme';
import TableCellEllipsis from '../../../shared/components/table/TableCellEllipsis';
import TableCellText from '../../../shared/components/table/TableCellText';
import { formatarCodigoLote, formatarDataEHora, formatarDataRequisicao } from '../../../shared/utils/Formatacao';
import { ExternalLink, FileText } from 'react-feather';
import { Link } from "react-router-dom";
import TooltipPersonalizado from '../../../shared/components/TooltipPersonalizado';
import { TEXT_SUCCESS_COLOR, YELLOW } from '../../../theme';
import { statusAmostra } from '../../../shared/utils/Enum';

const LinhaAmostras = ({ item, index, handleArquivosAmostra }) => {

    const tratarCirculoStatus = (status) => {
        switch (status) {
            case statusAmostra.recebido:
                return <span style={{ color: TEXT_SUCCESS_COLOR }}> • </span>;
            case statusAmostra.naoRecebido:
                return <span style={{ color: YELLOW }}> • </span>;
            default:
                return null;
        }
    };

    const classes = useStyles();

    const {
        codigo,
        codigoLote,
        tipoAmostra,
        tipoConservacao,
        numeroPedido,
        nomePaciente,
        status,
        dataCadastro,
        dataCadastroLote
    } = item

    return (
        <TableRow key={index + codigo} id={codigo}>

            <TableCellText text={codigo} />

            {codigoLote > 0 &&
                <TableCell style={{ width: "250px" }}>
                    <Link to={{ pathname: '/lotes', search: `codigoLote=${formatarCodigoLote(codigoLote)}&dataLote=${formatarDataRequisicao(dataCadastroLote)}` }}>

                        <LinkButton className="float-left mr-2"
                            icone={
                                <ExternalLink size={18}
                                    className={classes.linkCodigoLote}
                                    color={SECONDARY_COLOR}
                                />
                            }
                        />
                        <Typography className="float-left underline" >{formatarCodigoLote(codigoLote)}</Typography>
                    </Link>
                </TableCell>
            }

            {!codigoLote && <TableCellText text={codigoLote} width="250px" />}

            <TableCellEllipsis text={tipoAmostra?.descricao} width="120px" />
            <TableCellText text={tipoConservacao?.descricao} />
            <TableCellEllipsis text={numeroPedido} width="80px" />
            <TableCellEllipsis text={nomePaciente} width="120px" color="textPrimary" />
            <TableCellEllipsis text={
                <span>
                    {tratarCirculoStatus(status)}
                    {status}
                </span>
            } width="140px" color="textPrimary" />
            <TableCellText text={formatarDataEHora(dataCadastro)} />

            {item.quantidadeAnexos > 0
                ?
                <TableCell align="center">
                    <TooltipPersonalizado title="Visualizar arquivo(s)">
                        <FileText
                            size={tamanhoIcones}
                            className={classes.iconeArquivo}
                            onClick={() => handleArquivosAmostra(item)}

                        />
                    </TooltipPersonalizado>
                </TableCell>

                :

                <TableCell align="center">
                    <TooltipPersonalizado title="Sem arquivos anexados">
                        <FileText
                            size={tamanhoIcones}
                            className={classes.iconeArquivoDesabilitado}

                        />
                    </TooltipPersonalizado>
                </TableCell>
            }

        </TableRow >
    )

}

export default LinhaAmostras;

const tamanhoIcones = 20;
const useStyles = makeStyles((theme) => ({
    linkCodigoLote: {
        marginTop: "2px"
    },
    iconeArquivo: {
        color: SECONDARY_COLOR,
        marginTop: "5px",
        cursor: 'pointer',

    },
    iconeArquivoDesabilitado: {
        color: LIGHT_GRAY_COLOR,
        marginTop: "5px",
    }
}))

